import "./headline-section.scss";
const HeadlineSection = ({headline, secondHeadline}) => {
  return (
    <div className="headline-section">
        <h3>{headline} <span className="second-headline">{secondHeadline}</span></h3>
    </div>
  );
};

export default HeadlineSection;